import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Profile from "./views/Profile.vue";
import Registration from "./views/Registration.vue";
import Login from "./views/Login.vue";
import Activities from "./views/Activities.vue";
import Activity from "./views/Activity.vue";
import Leaderboard from "./views/Leaderboard.vue";
import Search from "./views/Search.vue";
import Articles from "./views/Articles.vue";
import Article from "./views/Article.vue";
import Recovery from "./views/Recovery.vue";
import NewPassword from "./views/NewPassword.vue";
import PageNotFound from "./views/PageNotFound.vue";
import DevelopmentSection from './components/DevelopmentSection.vue';
import Team from '@/views/Team.vue';
import store from "./store";
Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (store.getters['authentication/isAuthenticated']) {
    next();
    return;
  }
  next('/home');
}


export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: { name: 'activities' }},
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/user/:id",
      name: "user",
      component: Profile,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/team/:id",
      name: "team",
      component: Team,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/registration",
      name: "registration",
      component: Registration,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/recovery",
      name: "recovery",
      component: Recovery,
    },
    {
      path: "/new-password/:uid/:token",
      name: "newPassword",
      component: NewPassword,
    },
    {
      path: "/activities",
      name: "activities",
      component: Activities,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/activity/:id",
      name: "activity",
      component: Activity,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/leaderboard",
      name: "leaderboard",
      component: Leaderboard,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/articles",
      name: "articles",
      component: Articles,
      beforeEnter: ifAuthenticated,
    },
    {
      path: "/article/:id",
      name: "article",
      component: Article,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound,
    }, {
      path: '*',
      redirect: '/404'
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});
